import { render, staticRenderFns } from "./BedbuilderSummary.vue?vue&type=template&id=1f37f492&"
import script from "./BedbuilderSummary.vue?vue&type=script&lang=js&"
export * from "./BedbuilderSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports